import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageDialogConfig } from './message-dialog-config.interface';

@Component({
    selector: 'ca-error-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrl: './message-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MessageDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<MessageDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: MessageDialogConfig
    ) {}

    public onCancel(): void {
        this.dialogRef.close({ cancel: true });
    }
}
